import React from "react";
import { connect } from "react-redux";
import { Button, NumberBox, Popup, ScrollView, TextBox } from "devextreme-react";
import axios from "axios";
import { alert } from "devextreme/ui/dialog";

function GenerateAutoSubLotPopup(props) {
    var accessToken = props.oidc.user.access_token;
    const [records, setRecords] = React.useState(0);
    const GenerateAutoSubLots = async () => {
        const payload = {
            TransactionType: props.showPopup.TransactionType,
            Stage: props.showPopup.Stage,
            Records: records,
            RSubLot: props.showPopup.RSubLot,
            SubLotCode: props.showPopup.SubLotCode,
            ReceivingMethod: props.showPopup.ReceivingMethod,
            DuplicateSubLot: props.showPopup.DuplicateSubLot,
            DetailRowId: props.showPopup.DetailRowId,
            SubDetailRowId: props.showPopup.SubDetailRowId
        };
        try {
            const res = await axios.post(
                `${window._env_.REACT_APP_APIS}/wm/TransactionSubLot/GenerateAutoSubLots`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            );
            if (res.data.success) {
                props.setShowPopup(prevFormData => ({ ...prevFormData, Visible: false }));
                props.refreshSublotGrid();
            }
            else {
                alert(res.data.message, "Unable to Generate SubLots");
            }

        } catch (error) {
            console.error("Validation error:", error);
        }
    }
    return (<>
        {props.showPopup.Visible == true ? (
            <Popup
                visible={props.showPopup.Visible}
                onHiding={() => props.setShowPopup(prevFormData => ({ ...prevFormData, Visible: false }))}
                dragEnabled={false}
                hideOnOutsideClick={true}
                showCloseButton={true}
                showTitle={true}
                title={props.title}
                container="#root"
                width="20vw"
                height="20vh"
            >
                <div className="row">
                    <div className="col-md-12">
                        <NumberBox onValueChanged={(e) => setRecords(e.value)}
                            stylingMode="outlined"
                            labelMode="static"
                            label="Records" />
                    </div>
                </div>
                <div className="row"> 
                    <div className="col-md-12 mt-3">
                        <Button type="default" text="Generate" onClick={GenerateAutoSubLots} />
                    </div>
                </div>
            </Popup>) : (null)}
    </>);
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(GenerateAutoSubLotPopup);
